var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBigPlus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4999 0C11.2657 0 0.499878 10.7659 0.499878 24C0.499878 37.2341 11.2657 48 24.4999 48C37.734 48 48.4999 37.2341 48.4999 24C48.4999 10.7659 37.734 0 24.4999 0ZM34.9999 25.9999H26.4998V34.5C26.4998 35.6041 25.604 36.4999 24.4999 36.4999C23.3958 36.4999 22.5 35.6041 22.5 34.5V25.9999H13.9999C12.8958 25.9999 12 25.1041 12 24C12 22.8959 12.8958 22.0001 13.9999 22.0001H22.5V13.5C22.5 12.3959 23.3958 11.5001 24.4999 11.5001C25.604 11.5001 26.4998 12.3959 26.4998 13.5V22.0001H34.9999C36.104 22.0001 36.9998 22.8959 36.9998 24C36.9998 25.1041 36.104 25.9999 34.9999 25.9999Z",
    fill: "#F77E0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigPlus);
export default __webpack_public_path__ + "static/media/BigPlus.8530af1c889aafe3bb5899bfc11c02b6.svg";
export { ForwardRef as ReactComponent };